import { render } from "./parte1.vue?vue&type=template&id=78da2dc4&scoped=true"
import script from "./parte1.vue?vue&type=script&lang=js"
export * from "./parte1.vue?vue&type=script&lang=js"

import "./parte1.vue?vue&type=style&index=0&id=78da2dc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78da2dc4"]])

export default __exports__